import React, { useState } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import {FormattedMessage} from 'react-intl';

const GatewayOrder = (props) => {

  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("Are you sure you want to " + props.typeOfOrder + " of gateway "+ props.gw_name +" ?");


  const sendGwOrder = () =>{
      DataServiceSQL.orderGatewayAction(props.structure_Id, props.typeOfOrder, props.id)
      .then((response) => {
        setmessage("Request submitted to Gateway");
        setsubmitted(true);      
      })
      .catch((e) => {
        setmessage(<FormattedMessage id="message.error.gw.sendorder" defaultMessage="Oups, did not work... (err_code gw_sendorder)" />);
        setsubmitted(true);
      });
  }

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {submitted ? (
            <div>
            <center>
              <h4>{message}</h4>
              <button onClick={props.closeAfterUpgrade} className="btn btn-success">
                <FormattedMessage id="button.close" defaultMessage="Close" />
              </button>
              </center>
            </div>
          ) 
          :
          (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={sendGwOrder} className="btn btn-success">
                  {props.typeOfOrder}
                </button>
                <button onClick={props.cancelPopup} className="btn btn-danger">
                  Cancel
                </button>
              </center>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(GatewayOrder);
